import { render, staticRenderFns } from "./empleado.vue?vue&type=template&id=74f9c134&scoped=true"
import script from "./empleado.vue?vue&type=script&lang=js"
export * from "./empleado.vue?vue&type=script&lang=js"
import style0 from "./empleado.vue?vue&type=style&index=0&id=74f9c134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f9c134",
  null
  
)

export default component.exports